export class ListGroupConversationsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "groupEmail",
            "baseName": "groupEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "sortField",
            "baseName": "sortField",
            "type": "string",
            "format": ""
        },
        {
            "name": "sortAsc",
            "baseName": "sortAsc",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGroupConversationsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
